import React from 'react';

import { addressBookCsvProfile } from './addressBookCsvProfile';
import { ICsvUploadProfile, TUseCsvUploadController } from './csvUploadProfile';
import { useAddressBookCsvController } from './hooks/useAddressBookCsvController';
import UploadAddressesCSVModalContent from './UploadAddressesCSVModalContent';
import { UploadModalProvider } from './UploadModalContext';

interface IProps {
  isOpen: boolean;
  onClose: () => void;
  profile?: ICsvUploadProfile;
  useController?: TUseCsvUploadController;
}

const UploadAddressesCsvModal: React.FC<IProps> = ({
  isOpen,
  onClose,
  profile = addressBookCsvProfile,
  useController = useAddressBookCsvController,
}) => {
  return (
    <UploadModalProvider isOpen={isOpen} profile={profile} useController={useController}>
      <UploadAddressesCSVModalContent isOpen={isOpen} onClose={onClose} />
    </UploadModalProvider>
  );
};

export default UploadAddressesCsvModal;
